interface SeoProps {
  title: string;
  description: string;
  keywords?: string;
  canonicalPath?: string;
}

export default function Seo({
  title,
  description,
  keywords,
  canonicalPath,
}: SeoProps) {
  const base = typeof window !== "undefined" ? window.location.origin : "";
  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      {keywords ? <meta name="keywords" content={keywords} /> : null}
      {canonicalPath ? (
        <link rel="canonical" href={`${base}${canonicalPath}`} />
      ) : null}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
    </>
  );
}